import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';

import { blackberry, purple1, white, whiteTransparent70 } from 'lib/css/colors';

function BrandStatsDashboardBanner({
  title = 'Brand Stats',
  subtitle = 'Verification pipeline & product outlier cleanup overview',
}) {
  return (
    <div className={css(styles.headerSection)}>
      <div className={css(styles.headerContent)}>
        <div>
          <h1 className={css(styles.title)}>{title}</h1>
          <p className={css(styles.subtitle)}>{subtitle}</p>
        </div>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  headerSection: {
    background: `linear-gradient(135deg, ${blackberry} 0%, ${purple1} 100%)`,
    padding: '28px 40px',
  },
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: 1600,
    margin: '0 auto',
    gap: 24,
  },
  title: {
    fontSize: 28,
    fontWeight: 600,
    color: white,
    margin: 0,
  },
  subtitle: {
    fontSize: 14,
    color: whiteTransparent70,
    margin: '6px 0 0',
  },
});

BrandStatsDashboardBanner.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default BrandStatsDashboardBanner;
